import { initZipCodes, isZipAllowed } from '../services/zip-codes';

export function initKaiserZipCodes(url?: string): void {
	initZipCodes(url);
}

export function isCaliforniaZip(zip: string | undefined): boolean {
	return isZipAllowed(zip);
}

export function isKaiserPlanName(planName?: string): boolean {
	return /kaiser/i.test(planName || '');
}

export function getPlanNameByCode(
	plans: Array<{ code: string; name: string }> | undefined,
	code?: string,
): string | undefined {
	return plans?.find(p => p.code === code)?.name;
}

// Unified helper: pass either { planName } or { plans + code } with personZip
export function ShouldShowKaiserArbitration(args: {
	planName?: string;
	plans?: Array<{ code: string; name: string }>;
	code?: string;
	personZip?: string;
}): boolean {
	const resolvedName =
		args.planName ??
		(args.plans && args.code ? getPlanNameByCode(args.plans, args.code) : undefined);
	return isKaiserPlanName(resolvedName) && isCaliforniaZip(args.personZip);
}

